import Vue from "vue";
import Router from "vue-router";
import main from "@views/main";
import home from "./home/index";
import classify from "./classify/index";
import cart from "./cart/index";
import personal from "./personal/index";
import physicalStores from "./physicalStores/index";
import agency from "./agency/index";
import customOrder from "./customOrder/index";
import login from "./login/index";
import error from "./error/index";
import questions from "./questions/index";
import afterSaleComment from "./afterSaleComment/index";
import customerService from "./customerService/index";
import installStudy from "./install-study/index";
import prodIntro from "./prod-intro/index";
import fitting from "./fitting/index";
import cmt400 from "./400/index";
Vue.use(Router);

const mainRouter = [
  {
    path: "/",
    redirect: "/main/home",
  },
  {
    path: "/main",
    // component: main,
    component: (resolve) => require(["@views/main"], resolve),
    children: [],
  },
  {
    path: "/fitting",
    component: (resolve) => require(["@views/main"], resolve),
    children: [],
  },
  {
    path: "/400",
    component: (resolve) => require(["@views/main"], resolve),
    children: [],
  },
];

const configRouter = () => {
  mainRouter[1].children.push(...home);
  mainRouter[1].children.push(...classify);
  mainRouter[1].children.push(...cart);
  mainRouter[1].children.push(...personal);
  mainRouter[1].children.push(...physicalStores);
  mainRouter[1].children.push(...agency);
  mainRouter[1].children.push(...customOrder);
  mainRouter[1].children.push(...login);
  mainRouter[1].children.push(...questions);
  mainRouter[1].children.push(...afterSaleComment);
  mainRouter[1].children.push(...customerService);
  mainRouter[1].children.push(...installStudy);
  mainRouter[1].children.push(...prodIntro);
  mainRouter[2].children.push(...fitting);
  mainRouter[3].children.push(...cmt400);

  //注意：错误页面路由,必须放最后
  mainRouter[1].children.push(...error);
  return Promise.resolve(mainRouter);
};

export default configRouter;



// WEBPACK FOOTER //
// ./src/router/index.js